<div class="row g-0">
    <div class="col-12 col-lg-8">
        <div class="card-body">
            <h3 class="page-heading">Currency Conversion Settings</h3>
            <form [formGroup]="form" novalidate>
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="is_exchange_rate_fixed" [value]="false">
                    <label class="form-check-label">
                        Use daily rate exchange rate (changes daily)
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" formControlName="is_exchange_rate_fixed" [value]="true">
                    <label class="form-check-label">
                        Use specific day's exchange rate
                    </label>
                </div>
                <div *ngIf="form.controls.is_exchange_rate_fixed.value" class="col-sm-6 col-lg-5">
                    <jft-datepicker
                        [placeholder]="'Exchange rate date'"
                        [maxDate]="maxDate"
                        [enabled]="!loading"
                        formControlName="exchange_rate_date">
                    </jft-datepicker>
                    <small class="form-text text-muted"></small>
                </div>

                <hr>

                <h3 class="page-heading">Preferred Currencies and Units</h3>
                <div class="form-group">
                    <label>
                        Default Exchange Currency
                    </label>
                    <div class="input-group mb-3 col-12 col-md-6 px-0">
                        <jft-currency-select
                            class="w-100"
                            [allowClear]="false"
                            [currencyId]="form.controls.currency_id.value"
                            (onChange)="onCurrency($event)">
                        </jft-currency-select>
                    </div>
                </div>
                <div class="form-group">
                    <label>
                        Default Unit of Measurement
                    </label>
                    <div class="input-group mb-3 col-12 col-md-6 px-0">
                        <jft-units-select
                            class="w-100"
                            [allowClear]="false"
                            [unitId]="form.controls.units_id.value"
                            (onChange)="onUnit($event)">
                        </jft-units-select>
                    </div>
                </div>

                <hr>

                <h3 class="page-heading text-center mb-3">Currencies Used in this Tender</h3>

                <div class="row mb-3" *ngIf="!analyticSettingCurrencyRates.length">
                    <div class="col">There are no supplier's offers to show currency</div>
                </div>

                <div *ngFor="let analyticRate of analyticCurrencyRatesForm.controls; index as i"  class="row mb-3">
                    <ng-container [formGroup]="analyticRate">
                        <div class="col">
                            <h4 *ngIf="i < 1" class="page-heading">Exchange Rates</h4>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text {{!analyticRate.get('manual_rate').value ? 'bg-white text-dark' : ''}}">1 {{analyticRate.value.currency_code}} = </span>
                                </div>
                                <input type="text" class="form-control {{!analyticRate.get('manual_rate').value ? 'bg-white text-dark' : ''}}" formControlName="rate">
                                <span class="input-group-text {{!analyticRate.get('manual_rate').value ? 'bg-white text-dark' : ''}}">{{conversionFactor.currency.code}}</span>
                            </div>
                        </div>
                        <div class="col">
                            <h4 *ngIf="i < 1" class="page-heading">Manual Rates</h4>
                            <div class="input-group">
                                <input [textMask]="decimalMask" type="text" class="form-control" formControlName="manual_rate" placeholder="Different Exchange Rate">
                                <span class="input-group-text {{analyticRate.get('manual_rate').value ? 'bg-danger text-white' : ''}}">{{conversionFactor.currency.code}}</span>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <hr>

                <h3 class="page-heading">Units Used in this Tender</h3>

                <div class="row mb-3">
                    <div class="col">
                        <div class="input-group">
                            <span class="input-group-text">1 MT = </span>
                            <input type="text" class="form-control" placeholder="USG" disabled [value]="standardUsgPerMt ?? ''">
                            <span class="input-group-text">USG</span>
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group">
                            <input [mask]="decimalMask" type="text" formControlName="unit_conversion" class="form-control" placeholder="Different Conversion Factor">
                            <span class="input-group-text">USG</span>
                        </div>
                    </div>
                </div>

                <jft-submit-button *ngIf="user.canManageAdvanced()"
                    (onClick)="save()"
                    [loading]="form.disabled"
                    [class]="'btn btn-light mb-2'"
                    [disabled]="form.invalid || loading"
                    [ngbPopover]="getFirstFormGroupErrorLabel(form)" triggers="mouseenter:mouseleave" placement="left"
                    [title]="'Save'"
                    [loadingTitle]="'Saving'" triggers="mouseenter:mouseleave" placement="right">
                </jft-submit-button>

            </form>

        </div>
    </div>
    <div class="col-12 col-lg-4 bg-light border-start">
        <h3 class="card-header bg-light d-flex align-items-center min-height">
            <span class="fa-stack small me-1">
                <i class="fas fa-square fa-stack-2x"></i>
                <i class="fas fa-info fa-stack-1x fa-inverse"></i>
            </span> How It Works
        </h3>
        <div class="card-body">
            <p>Currency conversion settings determine how bids in different currencies are compared and analyzed.</p>

            <p class="mb-2"><strong>Exchange Rate Options:</strong></p>
            <ul class="small mb-3">
                <li><strong>Daily Rate:</strong> Uses current exchange rates that update automatically</li>
                <li><strong>Fixed Rate:</strong> Uses exchange rates from a specific date for consistent comparison</li>
            </ul>

            <p class="mb-2"><strong>Manual Rate Override:</strong></p>
            <p class="small mb-3">You can manually override API exchange rates by entering custom rates. Manual rates take precedence over both daily and fixed API rates for specific currencies.</p>

            <p class="mb-2"><strong>Unit Conversion:</strong></p>
            <p class="small mb-3">Converts bid quantities between different measurement units (gallons, liters, etc.) to ensure accurate comparison.</p>

            <p class="mb-2"><strong>Impact on Analysis:</strong></p>
            <p class="small mb-0">These settings affect all bid comparisons, rankings, and analytics throughout the tender process.</p>
        </div>
    </div>
</div>
